import Icon from '../../../components/AppIcon';

const ContactMethodsGrid = () => {
  const contactMethods = [
    {
      icon: "Phone",
      title: "Phone Call",
      primary: "082 793 5785",
      secondary: "Preferred for emergencies",
      action: () => window.location.href = 'tel:0827935785',
      highlight: true
    },
    {
      icon: "MessageSquare",
      title: "SMS/WhatsApp",
      primary: "082 793 5785",
      secondary: "Quick text inquiries",
      action: () => window.location.href = 'sms:0827935785',
      highlight: false
    },
    {
      icon: "Mail",
      title: "Email",
      primary: "info@meriodine.co.za",
      secondary: "Non-urgent inquiries",
      action: () => window.location.href = 'mailto:info@meriodine.co.za',
      highlight: false
    },
    {
      icon: "MapPin",
      title: "Service Area",
      primary: "Johannesburg Gauteng",
      secondary: "Local & reliable",
      action: null,
      highlight: false
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
      {contactMethods?.map((method, index) => (
        <div
          key={index}
          onClick={method?.action}
          className={`bg-card rounded-lg p-6 md:p-8 shadow-sm border-2 transition-all duration-300 ${
            method?.highlight
              ? 'border-accent hover:shadow-elevated cursor-pointer'
              : 'border-border hover:border-primary cursor-pointer'
          } ${!method?.action ? 'cursor-default' : ''}`}
        >
          <div className="flex items-start gap-4">
            <div
              className={`flex-shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center ${
                method?.highlight
                  ? 'bg-accent text-accent-foreground'
                  : 'bg-muted text-foreground'
              }`}
            >
              <Icon name={method?.icon} size={24} />
            </div>

            <div className="flex-1 min-w-0">
              <h3 className="font-headline font-semibold text-lg md:text-xl mb-2">
                {method?.title}
              </h3>
              <p className="font-accent font-semibold text-base md:text-lg text-primary mb-1 break-words">
                {method?.primary}
              </p>
              <p className="font-body text-sm md:text-base text-muted-foreground">
                {method?.secondary}
              </p>
            </div>

            {method?.action && (
              <Icon
                name="ArrowRight"
                size={20}
                className="flex-shrink-0 text-muted-foreground"
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ContactMethodsGrid;